import { AxiosError } from 'axios';
import { UseFormSetError } from 'react-hook-form';
import { UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { useFormMutation } from './use-form-mutation';

export type CreateProfileRequest = { givenName: string; familyName: string; role: string };

async function createProfile(request: CreateProfileRequest): Promise<undefined> {
    const { data } = await api.post('/profile', request);
    return data;
}

export function useCreateProfile(
    setError?: UseFormSetError<CreateProfileRequest>
): UseMutationResult<undefined, AxiosError, CreateProfileRequest, unknown> {
    return useFormMutation(createProfile, setError, {
        onSettled: () => {
            queryClient.invalidateQueries(['current-user']);
        },
    });
}
